<template>
  <div style="display: flex; align-items: center;">
    <tooltip label="View" type="default" placement="top">
      <a class="button button-table is-small" @click="view()">
        <i class="fa fa-eye"></i>
      </a>
    </tooltip>
    <tooltip label="History" type="default" placement="top">
      <a class="button button-table is-small" @click="history()">
        <i class="fa fa-align-right"></i>
      </a>
    </tooltip>
    <tooltip label="PDF" type="default" placement="top">
      <a class="button button-table is-small" @click="pdf()" v-if="!this.data.base_id">
        <i class="fa fa-file-pdf-o"></i>
      </a>
    </tooltip>
    <tooltip label="Excel" type="default" placement="top">
      <a class="button button-table is-small" @click="xls()" v-if="!this.data.base_id">
        <i class="fa fa-file-excel-o"></i>
      </a>
    </tooltip>
    <tooltip label="Comprovante" type="default" placement="top" v-if="parseInt(this.data.receipt) == 1">
      <div class="is-small" style="display: flex; align-items: center;">
        <i class="fa fa-check-square"></i>
      </div>
    </tooltip>
    <tooltip label="Boleto" type="default" placement="top" v-if="parseInt(this.data.invoice) == 1">
      <div class="is-small" style="display: flex; align-items: center;">
        <i class="fa fa-check-square-o"></i>
      </div>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import message from '../../../../utils/message'
  import Payment from './payment'
  export default {
    data () {
      return {}
    },
    props: {
      data: {
        type: Object,
        required: true
      },
      hotel: {
        type: String
      }
    },
    components: {
      Tooltip,
      Payment
    },
    methods: {
      pdf () {
        window.location.href = this.$store.state.config.apiURL + '/V2/payment/pdf/' + this.data.id
      },
      xls () {
        window.location.href = this.$store.state.config.apiURL + '/V2/payment/xls/' + this.data.id
      },
      invoice () {
        window.location.href = this.$store.state.config.apiURL + '/payment/invoice/' + this.data.id
      },
      receipt () {
        window.location.href = this.$store.state.config.apiURL + '/payment/receipt/' + this.data.id
      },
      revert () {
        let propsData = {
          context: this,
          payment: this.data,
          callback: 'revertCallback'
        }
        Payment.openRevertPayment(propsData)
      },
      revertCallback (result) {
        let propsData = {
          title: 'Success',
          message: 'The payment order was successfully reverted',
          type: 'success',
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
        this.$parent.loadData(true)
      },
      pay () {
        let propsData = {
          context: this,
          payment_id: this.data.id,
          currency: this.data.currency,
          amount: parseFloat(this.data.value),
          callback: 'payCallback'
        }
        Payment.openPayPayment(propsData)
      },
      view () {
        let propsData = {
          context: this,
          payment_id: this.data.id,
          edit: true,
          callback: 'viewCallBack',
          highlight: this.$parent.appendParams.hotel
        }
        Payment.openPayment(propsData)
      },
      viewCallBack () {
        this.$parent.loadData(true)
      },
      edit () {
        let propsData = {
          context: this,
          payment_id: this.data.id,
          deadline: this.data.deadline,
          payment_status: this.data.payment,
          payment_method: { id: this.data.payment_method_id, name: this.data.payment_method },
          pre_payment_method: this.data.pre_payment_method,
          callback: 'editCallback'
        }
        Payment.openEditPayment(propsData)
      },
      editCallback (result) {
        let propsData = {
          title: 'Success',
          message: 'The payment order was successfully edited',
          type: 'success',
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
        this.$parent.loadData(true)
      },
      merge () {
        let propsData = {
          context: this,
          payment: this.data,
          callback: 'mergeCallback'
        }
        Payment.mergePayment(propsData)
      },
      mergeCallback (result) {
        let propsData = {
          title: 'Success',
          message: 'The payment order was merged',
          type: 'success',
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
        this.$parent.loadData(true)
      },
      history () {
        let propsData = {
          context: this,
          payment_id: this.data.id,
          callback: ''
        }
        Payment.openHistoryPayment(propsData)
      },
      message (type, title, content) {
        let propsData = {
          title: title,
          message: content,
          type: type,
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
      },
      payCallback (result) {
        let propsData = {
          title: 'Success',
          message: 'The payment order was successfully payed',
          type: 'success',
          direction: 'down',
          duration: 4500,
          showCloseButton: true
        }
        message.openMessage(propsData)
        this.$parent.loadData(true)
      }
    }
  }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// PaymentsTableButtons.vue?f3a25f98